"use client"

import type { RESULTS_SORT_OPTIONS_MAPPING } from "@/modules/jobAds/client/constants"
import type { FunctionComponent, MouseEvent } from "react"

import { clsx } from "clsx"
import dynamic from "next/dynamic"
import { useState } from "react"

import { Button } from "@jobteaser/spark/components/Button"
import { SortDescending } from "@jobteaser/spark/components/Icons/SortDescending"

import { DEFAULT_RESULTS_SORT_OPTION } from "@/modules/jobAds/client/constants"
import { useJobAdsSearchParams } from "@/modules/jobAds/client/hooks/useJobAdsSearchParams"

import styles from "./ResultsSort.module.css"

type ResultsSortProps = {
  label: string
  recencyLabel: string
  relevanceLabel: string
}

type SortOption = {
  label: string
  value: Lowercase<keyof typeof RESULTS_SORT_OPTIONS_MAPPING>
}

const ResultsSortOptionDynamic = dynamic(() => import("./ResultSortOptions").then(mod => mod.ResultsSortOptions))

export const ResultsSort: FunctionComponent<ResultsSortProps> = ({ label, recencyLabel, relevanceLabel }) => {
  const searchParams = useJobAdsSearchParams()

  const sortOptions: [SortOption, SortOption, ...SortOption[]] = [
    {
      label: relevanceLabel,
      value: "relevance",
    },
    {
      label: recencyLabel,
      value: "recency",
    },
  ]

  const { label: valueLabel, value } =
    sortOptions.find(option => option.value === searchParams.get("sort")) ||
    sortOptions.find(option => option.value === DEFAULT_RESULTS_SORT_OPTION) ||
    sortOptions[0]

  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    setIsExpanded(!isExpanded)
  }

  const handleClose = (): void => {
    setIsExpanded(false)
  }

  return (
    <div className={styles.main}>
      <Button
        aria-label={valueLabel}
        className={clsx(styles.button, { [styles.button___expanded]: isExpanded })}
        icon={SortDescending}
        onClick={handleClick}
        variant="tertiary"
      />
      {isExpanded && (
        <ResultsSortOptionDynamic label={label} onClose={handleClose} options={sortOptions} value={value} />
      )}
    </div>
  )
}
